import { AuthView } from '../../hooks/useAuthForm';

interface AuthNavigationProps {
  view: AuthView;
  onViewChange: (view: AuthView) => void;
}

export default function AuthNavigation({ view, onViewChange }: AuthNavigationProps) {
  return (
    <div className="mt-3 space-y-2 text-center">
      {view === 'sign_up' && (
        <>
          <button
            type="button"
            onClick={() => onViewChange('sign_in')}
            className="block w-full text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary"
          >
            Already have an account? <span className="font-medium text-[#E34290]">Sign in</span>
          </button>
        </>
      )}

      {view === 'sign_in' && (
        <button
          type="button"
          onClick={() => onViewChange('forgotten_password')}
          className="block w-full text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary"
        >
          Forgot your password?
        </button>
      )}

      {(view === 'forgotten_password' || view === 'update_password') && (
        <button
          type="button"
          onClick={() => onViewChange('sign_in')}
          className="block w-full text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary"
        >
          Remember your password? <span className="font-medium text-[#E34290]">Sign in</span>
        </button>
      )}
    </div>
  );
}
